import React, { useState, useEffect } from "react";
import useFleetStore from "../../stores/useFleetStore";
import GoldStarDisplay from "../../Stars/GoldStarDisplay";
import FlagBoard from "../FlagBoard/FlagBoard";
import Reveal from "../../components/ui/Reveal";

const WeatherMap = () => {
    const [reloadKey, setReloadKey] = useState(0);

    // Hardcoded parameters – modify these as needed.
    const type = "map";
    const locationParam = "coordinates";
    const metricRain = "in";
    const metricTemp = "°F";
    const metricWind = "kt";
    const zoom = "12";
    const overlay = "radar";
    const product = "radar";
    const level = "surface";
    const lat = "42.641";
    const lon = "-83.432";
    const detailLat = "42.804";
    const detailLon = "-83.569";
    const detail = "true";
    const message = "true";

    // Concatenate the URL from the parameters.
    const windyUrl = `https://embed.windy.com/embed.html?type=${type}&location=${locationParam}&metricRain=${metricRain}&metricTemp=${metricTemp}&metricWind=${metricWind}&zoom=${zoom}&overlay=${overlay}&product=${product}&level=${level}&lat=${lat}&lon=${lon}&detailLat=${detailLat}&detailLon=${detailLon}&detail=${detail}&message=${message}`;

    useEffect(() => {
        const interval = setInterval(() => {
            setReloadKey((prev) => prev + 1);
        }, 1800000); // 30 minutes
        return () => clearInterval(interval);
    }, []);

    return (
        <iframe
            key={reloadKey}
            title="WindyMap"
            className="w-full h-full rounded-xl opacity-90"
            src={windyUrl}
        />
    );
};

const YoutubeVideo = () => {
    return (
        <div style={{ zIndex: 0 }} className="fixed inset-0 pointer-events-none">
            <iframe
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 min-w-full min-h-full allow-pointer-events-none"
                src="https://www.youtube.com/embed/qi0mY6zVQnY?autoplay=1&mute=1"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
            ></iframe>
        </div>
    );
};


const FishScreen = () => {
    const drones = useFleetStore((state) => state.drones);
    const flags = useFleetStore((state) => state.flags);

    const renderFlagBoard = () => (
        <div className="shrink-0"><Reveal show={!!flags && flags.length > 0}><FlagBoard /></Reveal></div>
    );

    const renderDroneCount = () => {
        const total = drones?.length ?? 0;
        // "Firefly Internal" = no customer FK (Phase A ownership model)
        const firefly = drones?.filter((drone) => drone.customer_org_id == null).length ?? 0;
        const flagCount = flags?.length ?? 0;
        const active = firefly - flagCount;

        return (
            <div className="text-center">
                <h2 className="text-3xl font-bold mb-4">DRONES AVAILABLE</h2>
                <div className="grid grid-cols-4 gap-4 font-semibold text-lg">
                    <div>ACTIVE</div>
                    <div>FLAGS</div>
                    <div>FIREFLY</div>
                    <div>TOTAL</div>
                </div>
                <div className="grid grid-cols-4 gap-4 mt-2 text-2xl font-extrabold">
                    <div>{active}</div>
                    <div>{flagCount}</div>
                    <div>{firefly}</div>
                    <div>{total}</div>
                </div>
            </div>
        );
    };


    return (
        // Full screen width; height is viewport height minus navbar height (assumed 64px)
        <div className="shopscreen flex flex-col w-screen h-[calc(100vh-64px)] text-white overflow-hidden">

            <YoutubeVideo />
            {/* Top header – content area */}
            <div className="flex-none p-4 text-center z-10">
                <h1 className="text-center text-4xl mb-2">
                    Welcome to <span className="username text-5xl font-bold">Firefly</span>!
                </h1>
            </div>

            {/* Main Content Area (Sidebar + Main) */}
            <div className="flex-1 flex overflow-hidden z-10 bg-black bg-opacity-50 rounded-xl scroll p-5">
                {/* Left Sidebar */}
                <div className="w-1/3 p-4 flex flex-col overflow-auto">
                    {/* Gold Star Display */}
                    <div className="mb-4">
                        <GoldStarDisplay />
                    </div>

                    <div className="mb-4">
                        {renderDroneCount()}
                    </div>

                    <div className="mb-4 flex-1">
                        <WeatherMap />
                    </div>
                </div>

                {/* Right Main Content */}
                <div className="flex-1 flex flex-col gap-4 p-4 overflow-auto min-h-0">
                    {renderFlagBoard()}
                </div>

            </div>
            <div className="flex-none p-4 text-center z-10 mb-10">
                <h1 className="text-center text-2xl mb-2">
                    do drone shows.
                </h1>
            </div>

        </div>
    );
};

export default FishScreen;
